import {Container, List, Segment, Table} from "semantic-ui-react";
import React, {useEffect, useState} from "react";
import {AppListPageDialogContext} from "../../common/AppListPage";
import {SurveySessionAnswerModel, SurveySessionModel} from "../model/SurveySessionModel";
import {
    SurveyFormAnswerModel,
    SurveyFormModel,
    SurveyFormQuestionModel,
    SurveyFormQuestionType
} from "../model/SurveyFormModel";
import {SurveyFormDataProvider} from "../service/SurveyFormDataProvider";
import {Utils} from "../../../helpers/Utils";

interface Props {
    context: AppListPageDialogContext<SurveySessionModel>
}

const SurveySessionDetails = (props: Props) => {
    const [form, setForm] = useState<SurveyFormModel>();
    const formsProvider = new SurveyFormDataProvider();

    useEffect(() => {
        if (props.context.model) {
            formsProvider.getByID(props.context.model.formId).then(setForm);
        }
    }, []);

    function getAnswerDisplayText(question: SurveyFormQuestionModel, answer: SurveySessionAnswerModel | undefined): string[] {
        if (answer) {
            if (question.type == SurveyFormQuestionType.choice) {
                const result: string[] = [];
                for (const v of answer.value.split(",")) {
                    const choice = question.choices.find((x) => x.value == v);
                    if (choice) {
                        result.push(choice.displayText);
                    }
                }
                return result;
            }
            else if (question.type == SurveyFormQuestionType.bool) {
                if (answer.value == "true")
                    return ["✅ " + (question.buttonTrueDisplayText ?? "ДА")]
                else if (answer.value == "false")
                    return ["❌ " + (question.buttonFalseDisplayText ?? "НЕТ")]

            }
        }

        return answer?.value ? [answer!.value] : [];
    }

    function getRows(questions: SurveyFormQuestionModel[], level: number, parentNumber: string | undefined = undefined) {
        const result: JSX.Element[] = [];
        let number = 0;
        for (const question of questions) {
            const n = (parentNumber ? parentNumber : "") + (++number).toString();
            const answer = props.context.model?.answers?.find((x) => x.questionId === question.id);
            const answerDisplayText = getAnswerDisplayText(question, answer ? answer as SurveySessionAnswerModel : undefined);
            const marginLeft = 20 * level;
            result.push(
                <Table.Row verticalAlign={"top"}>
                    <Table.Cell><p style={{marginLeft: marginLeft}}>{parentNumber}{n}</p></Table.Cell>
                    <Table.Cell><p style={{marginLeft: marginLeft}}>{question.questionDisplayText}</p></Table.Cell>
                    <Table.Cell positive={!!answer} negative={!answer}>
                        {answerDisplayText.length > 0 && <List>
                            {answerDisplayText.map((x) => <List.Item>{x}</List.Item>)}
                        </List>}
                    </Table.Cell>
                </Table.Row>);
            const answerValues = answer?.value?.split(",") ?? [];
            if (question.answers) {
                for (const answer of question.answers) {
                    if (answer.questions.length > 0 && answerValues.find((x) => x == answer.choice.value)) {
                        result.push(
                            <Table.Row>
                                <Table.Cell colSpan={3} warning>
                                    <p
                                        style={{marginLeft: marginLeft + 10, fontStyle: "italic"}}>если
                                        - {answer.choice.displayText}</p></Table.Cell>
                            </Table.Row>);
                        result.push(...getRows(answer.questions, level + 1, `${number}.`))
                    }
                }
            }
        }
        return result;
    }

    return <Container fluid>
        {form &&
            <>
                <h4>{props.context.model?.patientName}</h4>
                <h4>{props.context.model?.campaignName}</h4>
                {props.context.model?.finishedAt &&
                <h5>{Utils.formatDateTime(props.context.model?.startedAt) + " - " + Utils.formatDateTime(props.context.model?.finishedAt) }</h5>}
                <Segment style={{height: "500px", overflowY: "auto"}}>

                    <Table celled selectable verticalAlign='middle' size={"small"}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>№</Table.HeaderCell>
                                <Table.HeaderCell width={6}>Вопрос</Table.HeaderCell>
                                <Table.HeaderCell width={5}>Ответ</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {[...getRows(form.questions, 0)]}
                        </Table.Body>
                    </Table></Segment>
            </>}
    </Container>;
}

export default SurveySessionDetails;